/**
 * 계통 개요 그림의 자료형 — 생성기(`scripts/gen-system-diagram.ts`)가 공식 계통도(pptx)에서 뽑아
 * `systemDiagram.generated.ts` 에 굳히고, 그림 컴포넌트(`ReactorSystemSVG`)가 그린다.
 * 도형 이름은 원본의 층을 품는다(`P__CVCS__212`) — 층 → 계통은 `systemDiagramLayers.ts` 가 정한다.
 */
export type DiagramShapeKind = 'path' | 'rect' | 'roundRect' | 'ellipse';

export interface DiagramText {
  /** 단락마다 한 줄 — 한 단락의 여러 run 은 이어 붙인다 */
  lines: string[];
  /** 글자 크기(px) */
  size: number;
  bold: boolean;
  color: string | null;
  align: 'l' | 'ctr' | 'r';
  anchor: 't' | 'ctr' | 'b';
}

export interface DiagramShape {
  /** PPT 도형 이름 그대로 — 층 접두와 번호 */
  name: string;
  kind: DiagramShapeKind;
  x: number;
  y: number;
  w: number;
  h: number;
  /** `path` 의 d — 도형 좌표계(x·y 기준 상대) px */
  d?: string;
  /** `roundRect` 의 모서리 반지름 px */
  rx?: number;
  flipH?: boolean;
  flipV?: boolean;
  fill: string | null;
  stroke: string | null;
  strokeWidth: number;
  /** 점선 패턴(px) — 실선이면 null */
  dash: number[] | null;
  text?: DiagramText;
}

export interface SystemDiagram {
  /** [x, y, w, h] */
  viewBox: [number, number, number, number];
  background: string;
  shapes: DiagramShape[];
}

/** 도형 이름의 층 — 뒤의 `__번호` 를 뗀 것(`P__CVCS__212` → `P__CVCS`, `UI__UI_493__1` → `UI`) */
export function layerOf(name: string): string {
  const stripped = name.replace(/__\d+$/, '');
  return stripped.startsWith('UI__') ? 'UI' : stripped;
}
